const cityGoals = [
  {
    title: "Government that Works for All",
    fullTitle: "Government that Works for All",
    description: "Believing that city government works effectively and collaboratively for all of us - that it is equitable, ethical, and innovative.",
  }, {
    title: "Economy & Affordability",
    fullTitle: "Economic Opportunity & Affordability",
    description: "Having economic opportunities and resources that enable us to thrive in our community.",
  }, {
    title: "Safety",
    fullTitle: "Safety",
    description: "Being safe in our home, at work, and in our community.",
  }, {
    title: "Health & Environment",
    fullTitle: "Health & Environment",
    description: "Enjoying a sustainable environment and a healthy life, physically and mentally.",
  }, {
    title: "Mobility",
    fullTitle: "Mobility",
    description: "Getting us where we want to go, when we want to get there, safely and cost-effectively.",
  }, {
    title: "Culture & Lifelong Learning",
    fullTitle: "Culture & Lifelong Learning",
    description: "Being enriched by Austin's unique civic, cultural, ethnic, and learning opportunities.",
  },
];

export default cityGoals;
